<template>
    <form
        method="post"
        @submit.prevent="submit"
        @keydown="clearErrors($event.target.name)"
    >
        <div
            class="form-group has-feedback"
            :class="{ 'has-error': form.errors.has('gRecaptchaResponse') }"
        >
            <google-re-captcha-v3
                :id="'google_recaptcha'"
                ref="captcha"
                v-model="form.gRecaptchaResponse"
                :siteKey="siteKey"
                :inline="false"
                :action="'signin'"
            >
            </google-re-captcha-v3>
            <transition name="fade">
                <span
                    v-if="form.errors.has('gRecaptchaResponse')"
                    id="validation_error_gRecaptchaResponse"
                    class="help-block"
                    v-text="form.errors.get('gRecaptchaResponse')"
                ></span>
            </transition>
        </div>
        <div
            v-show="form.succeeded"
            id="result"
            class="alert alert-success text-center"
        >
            {{ trans('lang_message.loggedin') }}
            <i class="fa fa-refresh fa-spin"></i>
            {{ trans('lang_message.entering') }}
        </div>
        <div
            v-if="type === 'email'"
            v-show="!isTwoFactorForm"
            class="form-group has-feedback"
            :class="{ 'has-error': form.errors.has('email') }"
        >
            <input
                v-model="form.email"
                type="email"
                class="form-control"
                :placeholder="placeholder"
                :name="name"
                value=""
                autofocus
                @change="adddomain"
            />
            <span
                class="glyphicon form-control-feedback"
                :class="[icon]"
            ></span>
            <transition name="fade">
                <span
                    v-if="form.errors.has('email')"
                    id="validation_error_email"
                    class="help-block"
                    v-text="form.errors.get('email')"
                ></span>
            </transition>
        </div>
        <div
            v-else
            v-show="!isTwoFactorForm"
            class="form-group has-feedback"
            :class="{ 'has-error': form.errors.has('username') }"
        >
            <input
                v-model="form.username"
                type="text"
                class="form-control"
                :placeholder="placeholder"
                :name="name"
                autofocus
                @change="adddomain"
            />
            <span
                class="glyphicon form-control-feedback"
                :class="[icon]"
            ></span>
            <transition name="fade">
                <span
                    v-if="form.errors.has('username')"
                    id="validation_error_username"
                    class="help-block"
                    v-text="form.errors.get('username')"
                ></span>
            </transition>
        </div>
        <div
            v-show="!isTwoFactorForm"
            class="form-group has-feedback"
            :class="{ 'has-error': form.errors.has('password') }"
        >
            <input
                v-model="form.password"
                type="password"
                class="form-control"
                :placeholder="trans('lang_message.password')"
                name="password"
            />
            <span class="glyphicon glyphicon-lock form-control-feedback"></span>
            <transition name="fade">
                <span
                    v-if="form.errors.has('password')"
                    id="validation_error_password"
                    class="help-block"
                    v-text="form.errors.get('password')"
                ></span>
            </transition>
        </div>
        <div class="row">
            <div class="col-xs-8">
                <div
                    v-show="!isTwoFactorForm"
                    class="checkbox icheck"
                >
                    <label>
                        <input
                            v-model="form.remember"
                            type="checkbox"
                            name="remember"
                        />
                        {{ trans('lang_message.remember') }}
                    </label>
                </div>
            </div>
            <div class="col-xs-8">
                <div
                    v-show="isTwoFactorForm"
                    class=""
                    :class="{ 'has-error': form.errors.has('tfa_code') }"
                >
                    <input
                        v-if="isTwoFactorForm"
                        id="tfa_code"
                        v-model="form.tfa_code"
                        type="text"
                        class="form-control"
                        :placeholder="placeholder"
                        :name="name"
                        minlength="6"
                        autofocus
                        required
                    />

                    <transition name="fade">
                        <span
                            v-if="form.errors.has('tfa_code')"
                            class="help-block"
                            v-text="form.errors.get('tfa_code')"
                        >
                        </span>
                    </transition>
                </div>
            </div>
            <div class="col-xs-4">
                <button
                    type="submit"
                    class="btn btn-primary btn-block btn-flat"
                    :disabled="isButtonDisabled"
                >
                    {{ trans('lang_message.buttonsign') }}
                    <i
                        v-if="form.submitting"
                        class="fa fa-refresh fa-spin"
                    ></i>
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import Form from 'acacha-forms';
import initialitzeIcheck from './InitializeIcheck';
import redirect from './redirect';

import GoogleReCaptchaV3 from '../googlerecaptchav3/GoogleReCaptchaV3';

export default {
    components: {
        GoogleReCaptchaV3,
    },
    mixins: [initialitzeIcheck, redirect],
    props: {
        name: {
            type: String,
            required: true,
        },
        domain: {
            type: String,
            default: '',
        },
        siteKey: {
            type: String,
            required: true,
        },
    },
    data: function () {
        let form = new Form({
            username: '',
            password: '',
            remember: '',
            gRecaptchaResponse: '',
        });
        if (this.name === 'email') {
            form = new Form({
                email: '',
                password: '',
                remember: '',
                gRecaptchaResponse: '',
            });
        }
        return {
            form: form,
            isButtonDisabled: true,
            isTwoFactorForm: false,
        };
    },
    computed: {
        placeholder: function () {
            if (this.name === 'email') return this.trans('lang_message.email');
            return this.trans('lang_message.username');
        },
        type: function () {
            if (this.name === 'email') return 'email';
            return 'text';
        },
        icon: function () {
            if (this.name === 'email') return 'glyphicon-envelope';
            return 'glyphicon-user';
        },
    },
    watch: {
        'form.remember': function (value) {
            if (value) {
                $('input').iCheck('check');
            } else {
                $('input').iCheck('uncheck');
            }
        },
    },
    mounted() {
        this.initialitzeICheck('remember');
    },
    methods: {
        submit() {
            this.isButtonDisabled = true;
            this.form
                .post('/login')
                .then((response) => {
                    var component = this;
                    component.redirect(response);
                })
                .catch((error) => {
                    if (this.isTwoFactorForm) {
                        this.form.errors.errors = {
                            tfa_code: ['The 2FA Code is invalid or has expired.'],
                        };
                    }
                    if (error.response.status === 403) {
                        $('#login-box-msg').text('To log in, open up your Authenticator app and issue the 6-digit code.');
                        this.isTwoFactorForm = true;
                        this.form.originalFields = {
                            ...this.form.originalFields,
                            tfa_code: '',
                        };
                    }

                    this.refreshRecaptchaToken();
                    console.log(this.trans('lang_message.loginerror') + ':' + error);
                });
        },
        adddomain: function () {
            if (this.type === 'email') return;
            if (this.domain === '') return;
            if (this.form.username.endsWith(this.domain)) return;
            if (this.form.username.includes('@')) return;
            this.form.username = this.form.username + '@' + this.domain;
        },
        clearErrors(name) {
            if (name === 'password') {
                this.form.errors.clear('password');
                name = this.name;
            }
            this.form.errors.clear(name);
        },
        refreshRecaptchaToken() {
            this.$refs.captcha.execute();
        },
    },
};
</script>

<style src="./fade.css"></style>
